import { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import { useNavigate } from "react-router-dom";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";

export const NewPromoCategoryCommisionModal = ({
  showModalPromoCategoryCommision,
  setShowModalPromoCategoryCommision,
  selectedPromoCategoryCommision,
  setSelectedPromoCategoryCommision
}) => {
  let navigate = useNavigate();
  let handleClose = (e) => {
    //e.stopPropagation();
    //navigate(-1);
    setShowModalPromoCategoryCommision(false);
  };
  let defaultValues = {}
  if (selectedPromoCategoryCommision) {
    defaultValues = {
      name: selectedPromoCategoryCommision.name,
      PromoCategoryId: selectedPromoCategoryCommision.promoCategory.id,
      isDefault: selectedPromoCategoryCommision.isDefault,
      isActive: selectedPromoCategoryCommision.isActive
    }
  }
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues,
  });
  const [listData, setListData] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const rest = await ApiPromoCategory.getAll({ pageSize: 99, pageNumber: 1 });
        rest?.data && setListData(rest.data);
        if (selectedPromoCategoryCommision.promoCategory.id)
          setValue("PromoCategoryId", rest.data.map((item) => ({
            value: item.id,
            label: item.name,
          })).find(item => item.value == selectedPromoCategoryCommision.promoCategory.id))
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  const onSubmit = async (data) => {
    if (data.PromoCategoryId) data.PromoCategoryId = data.PromoCategoryId.value
    try {
      const sendData = { ...data }
      if (selectedPromoCategoryCommision) sendData.id = selectedPromoCategoryCommision.id

      let response = await ApiPromocategorycommision.addOrEditPromoCategoryCommision(sendData);

      if (!response.succeeded) {
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        return
      }
      if (response.data > 0 && !selectedPromoCategoryCommision) {
        navigate("/CreateEditAmusementServicePromoCategoryCommision/" + response.data);
      }
      setShowModalPromoCategoryCommision(false);
      setSelectedPromoCategoryCommision(null)
      document.getElementById("submitButton").click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });

      // SwalMessage({ title: response.message  , iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalPromoCategoryCommision} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedPromoCategoryCommision ? "ویرایش گروه کمیسیون" : "ایجاد گروه کمیسیون جدید"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label=" نام گروه کمیسیون "
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {errors.name && <span className="text-danger">** لطفا نام گروه کمیسیون را وارد نمایید</span>}
            </Col>
            <Col xs="12">
              <Controller
                name="PromoCategoryId"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-2"
                    placeholder="انتخاب گروه تخفیف"
                    options={listData?.filter(item => item.isActive).map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    field={field}
                  />
                )}
              />
              {errors.PromoCategoryId && <span className="text-danger"> ** لطفا گروه تخفیف را انتخاب نمایید</span>}
            </Col>
            <Col xs="12" >
              <div className="d-flex gap-5">
                <FormControlLabel
                  control={
                    <Controller
                      name="isDefault"
                      control={control}
                      render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                        <Checkbox onBlur={onBlur} onChange={onChange} checked={value} inputRef={ref} color="primary" />
                      )}
                    />
                  }
                  label="پیش فرض"
                />
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"isActive"}
                      render={({ field: { onChange, value, ref } }) => (
                        <Checkbox color="primary" onChange={onChange} checked={value || false} inputRef={ref} />
                      )}
                    />
                  }
                  label="فعال"
                /></div>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
